import React from 'react';

import TextTag from './TextTag';

const TextTagFormField = ({ input, ...props }) => {
  return <TextTag {...props} onChange={input.onChange} chips={input.value} />
};

export default TextTagFormField;



// WEBPACK FOOTER //
// ./src/components/forms/TextTagFormField.js